import ProductLayout from '@/pages/product/layout'
import ProductIndexPage from '@/pages/product/index'
import ProductViewLayout from '@/pages/product/viewTabs/layout'
import ProductViewIndexPage from '@/pages/product/viewTabs/index'
import ProductViewMemberPage from '@/pages/product/viewTabs/member.vue'
import ProductUpdateIndexPage from '@/pages/product/updateTabs/index'

var routes = {
	path: '/product',
	component: ProductLayout,
	meta: {title: 'Продукты', breadcrumb: 'Продукты'},
	children: [
		{
			path: '',
			component: ProductIndexPage,
			meta: {title: 'Продукты'}
		}, {
			path: ':id',
			component: ProductViewLayout,
			meta: {title: 'Продукты'},
			children: [
				{
					path: 'update',
					component: ProductUpdateIndexPage,
					meta: {title: 'Редактирование продукта'}
				}, {
					path: 'view',
					component: ProductViewIndexPage,
					meta: {title: 'Информация | Продукты'}
				}, {
					path: 'members',
					component: ProductViewMemberPage,
					meta: {title: 'Участники | Продукты'}
				}
			]
		}
	]
}
export default {
	routes
}



// WEBPACK FOOTER //
// ./src/routes/product.js